import { Lightbulb, Newspaper, Sparkles, TrendingUp, BookOpen, Scissors } from 'lucide-react';
import { batch1Articles } from './blog/batch1';
import { batch2Articles } from './blog/batch2';
import { batch3Articles } from './blog/batch3';
import { batch4Articles } from './blog/batch4';
import { batch5Articles } from './blog/batch5';

export interface BlogArticle {
  slug: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  date: string;
  category: string;
  cluster: string;
  readTime: string;
  keywords: string[];
  tags?: string[];
  author?: string;
  content: string;
  summaryTitle: string;
  summaryPoints: string[];
  ctaLabel: string;
  ctaLink: string;
  relatedSlugs: string[];
}

export function getArticleTags(article: BlogArticle): string[] {
  return article.tags ?? article.keywords.slice(0, 4);
}

export function getArticleAuthor(article: BlogArticle): string {
  return article.author ?? 'Carine — Body by CC';
}

export const blogCategoryData = [
  { label: 'Épilation', icon: Scissors },
  { label: 'Soins Visage', icon: Sparkles },
  { label: 'Soins Corps', icon: TrendingUp },
  { label: 'Beauté Mains & Pieds', icon: Lightbulb },
  { label: 'Conseils Beauté', icon: BookOpen },
  { label: 'Actualités Institut', icon: Newspaper },
] as const;

export const blogCategories = blogCategoryData.map((c) => c.label);

export const blogArticles: BlogArticle[] = [
  ...batch1Articles,
  ...batch2Articles,
  ...batch3Articles,
  ...batch4Articles,
  ...batch5Articles,
];

export function getBlogArticleBySlug(slug: string): BlogArticle | undefined {
  return blogArticles.find((a) => a.slug === slug);
}

export function getRelatedArticles(article: BlogArticle): BlogArticle[] {
  return article.relatedSlugs
    .map((s) => blogArticles.find((a) => a.slug === s))
    .filter(Boolean) as BlogArticle[];
}
